<template>
    <b-row>
        <b-col>
            <b-row>
                <b-col v-if="showMessages" cols="8">
                    <b-collapse id="new-message-box" v-model="messageFormOpened">
                        <b-card border-variant="primary" class="mb-2">
                            <new-message-form @closeMessageForm="onCloseMessageForm" ref="newMessageForm"></new-message-form>
                        </b-card>
                    </b-collapse>
                    <b-row>
                        <b-col class="text-right">
                            <b-btn
                                :size="'sm'"
                                class="btn-primary mb-2"
                                :disabled="!projectPermissions.includes('CREATE_MESSAGE')"
                                @click="messageFormOpened = !messageFormOpened; resetMessageFormValidators();"
                                v-show="!messageFormOpened">
                                {{ $t('feed.newMessage.name') }}
                            </b-btn>
                        </b-col>
                    </b-row>
                    <project-feed></project-feed>
                </b-col>
                <b-col cols="4">
                    <project-collaborators></project-collaborators>
                    <project-tasks v-if="showTasks"></project-tasks>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import ProjectFeed from './Feed/ProjectFeed';
import ProjectTasks from './ProjectTasks';
import ProjectCollaborators from './ProjectCollaborators';
import NewMessageForm from '../../Shared/NewMessageForm';

export default {
    components: {
        NewMessageForm,
        ProjectFeed,
        ProjectTasks,
        ProjectCollaborators
    },

    data() {
        return {
            messageFormOpened: false
        }
    },

    created() {
        this.$store.dispatch('system/loadInputLimits');
    },

    computed: {
        projectTitle() {
            return this.$store.state.projects.currentProject.projectData.name;
        },

        projectDescription() {
            return this.$store.state.projects.currentProject.projectData.description;
        },

        showMessages() {
            return this.$store.state.projects.currentProject.projectData.showMessages;
        },

        showTasks() {
            return this.$store.state.projects.currentProject.projectData.showTasks;
        },
        projectPermissions() {
          if(this.$store.state.projects.currentProject.projectData.role){
            return this.$store.state.projects.currentProject.projectData.role.permissions;
          } else {
            return [];
          }
        },
    },
    
    methods: {
        onCloseMessageForm() {
            this.messageFormOpened = false;
        },

        resetMessageFormValidators() {
            this.$refs.newMessageForm.$validator.reset();
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
